import { render, staticRenderFns } from "./NavigationTabs.vue?vue&type=template&id=566c054a"
import script from "./NavigationTabs.vue?vue&type=script&lang=ts"
export * from "./NavigationTabs.vue?vue&type=script&lang=ts"
import style0 from "./NavigationTabs.vue?vue&type=style&index=0&id=566c054a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports